'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAPIEndpoint = exports.canUseDOM = exports.isClient = exports.HOME = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.isInvalidID = isInvalidID;
exports.buildQueryString = buildQueryString;
exports.getCountryCode = getCountryCode;
exports.isPublic = isPublic;
exports.isPublicHost = isPublicHost;
exports.getNuiBaseUrlFromHost = getNuiBaseUrlFromHost;
exports.getAppCenterPathName = getAppCenterPathName;
exports.getNuiLanguage = getNuiLanguage;
exports.mapCountryToPublicLang = mapCountryToPublicLang;
exports.getCanonicalLink = getCanonicalLink;
exports.getHreflangLinks = getHreflangLinks;
exports.sendPublicView = sendPublicView;
exports.escapeHTML = escapeHTML;

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var HOME = exports.HOME = 'home';

var isClient = exports.isClient = typeof document !== 'undefined';

var canUseDOM = exports.canUseDOM = function canUseDOM() {
  return typeof window !== 'undefined' && window.document && window.document.createElement;
};

/**
 * Determines if the given ID is invalid, to prevent JS injection
 * @param {string} id id of the listing
 * @returns {string} true if invalid, false if valid
 * @throws will throw if the given url is empty
 */
function isInvalidID(id) {
  if (id === undefined) throw new Error('must provide an ID');

  var re = new RegExp('[^-A-Za-z0-9+&@#/%?=~_$|!:,.;()]');
  return re.test(id);
}

var getAPIEndpoint = exports.getAPIEndpoint = function getAPIEndpoint() {
  if (canUseDOM()) {
    return _config2.default.appcenterAPIBase.client + '/api/';
  }
  return _config2.default.appcenterAPIBase.server + '/api/';
};

function buildQueryString(parameters) {
  // TODO: remove this function once node 7.3+ becomes ubiquitous
  var ObjectToArray = function ObjectToArray(x) {
    return Object.keys(x).reduce(function (y, z) {
      return y.push([z, x[z]]) && y;
    }, []);
  };

  var qs = ObjectToArray(parameters).reduce(function (acc, curr) {
    var _curr = _slicedToArray(curr, 2),
        key = _curr[0],
        value = _curr[1];

    if (Object.hasOwnProperty.call(parameters, key)) {
      if (value) {
        return '' + acc + encodeURIComponent(key) + '=' + encodeURIComponent(value) + '&';
      }
    }
    return acc;
  }, '');

  if (qs.length > 0) {
    return '?' + qs.substring(0, qs.length - 1); // chop off last "&"
  }
  return '';
}

/**
 * Determines the Country Code that should be used for a given domain
 * @param {string} url the url the request originates from
 * @returns {string} a Country Code
 * @throws will throw if the given url is empty
 */
function getCountryCode(url) {
  if (!url && url != '') throw new Error('must provide a url');

  var lowerURL = url.toLowerCase();
  var urlToLang = new Map([['concur.co.jp', 'JP'], ['concur.co.uk', 'GB'], ['concur.com.au', 'AU'], ['concur.de', 'DE'], ['concur.com', 'US'], ['concur.ca', 'CA'], ['concur.com.mx', 'MX'], ['concur.cn', 'CN']]);

  if (urlToLang.has(lowerURL)) return urlToLang.get(lowerURL);

  // wasn't an exact match, look for partial match (e.g. concur.com.nonprod.cnqr.tech)
  var match = [].concat(_toConsumableArray(urlToLang.entries())).find(function (elem) {
    return lowerURL.includes(elem[0]);
  });

  return match ? match[1] : 'US';
}

/**
 * Determines if the given path represents a public version of appcenter
 * @param {string} path the current path e.g. /app-center, /nui/appcenter
 * @returns {boolean} true if public, false if not
 */
function isPublic(path) {
  return (/app-center|app-centre/.test(path)
  );
}

/**
 * Determines if the given host is a public appcenter domain
 * @param {string} host e.g. concur.com, concursolutions.com
 * @returns {boolean} true if public, false if not
 * @throws will throw if the given host is empty
 */
function isPublicHost(host) {
  if (!host && host != '') throw new Error('must provide host');

  var publicDomains = ['concur.co.jp', 'concur.co.uk', 'concur.com.au', 'concur.de', 'concur.com', 'concur.ca', 'concur.com.mx', 'concur.cn'];
  return publicDomains.some(function (domain) {
    return host.toLowerCase().includes(domain);
  });
}

function getNuiBaseUrlFromHost(host) {
  return isPublicHost(host) ? 'app-center' : _config2.default.nui.baseUrl;
}

/**
 * Determines the base path to use for building links
 * @param {string} path the current path e.g. /nui/appcenter/listing/1
 * @returns {string} a base to use for building links e.g. /nui/appcenter
 * @throws will throw if the given path does not match
 */
function getAppCenterPathName(path) {
  var publicRegex = new RegExp(/app-center|app-centre/);
  var privateRegex = new RegExp(/nui\/appcenter/);
  var errorRegex = new RegExp(/404/);

  if (publicRegex.test(path)) return '/' + path.match(publicRegex)[0];
  if (privateRegex.test(path)) return _config2.default.nui.baseUrl;
  if (errorRegex.test(path)) return '/404';

  throw new Error('given pathname "' + path + '" not supported');
}

/**
 * Determines the language FOR NUI to use for different public appcenter domains
 * @param {string} domain the current domain e.g. concur.co.jp
 * @returns {string} language code, defaults to en e.g. 'jp'
 * @throws will throw if the given domain is empty
 */
function getNuiLanguage(domain) {
  if (!domain && domain != '') throw new Error('must provide domain');

  var lowerDomain = domain.toLowerCase();
  var domainToLang = new Map([['concur.co.jp', 'ja'], ['concur.co.uk', 'en-gb'], ['concur.com.au', 'en-gb'], ['concur.com', 'en'], ['concur.de', 'de'], ['concur.ca', 'en'], ['concur.com.mx', 'es-la'], ['concur.cn', 'zh-cn']]);

  if (domainToLang.has(lowerDomain)) return domainToLang.get(lowerDomain);

  // wasn't an exact match, look for partial match (e.g. concur.com.nonprod.cnqr.tech)
  var match = [].concat(_toConsumableArray(domainToLang.entries())).find(function (elem) {
    return lowerDomain.includes(elem[0]);
  });

  return match ? match[1] : 'en';
}

/**
 * Determines the language FOR PUBLIC WRAPPER to use
 * @param {string} domain the current domain e.g. concur.co.jp
 * @returns {string} language code, defaults to en e.g. 'ja-jp'
 * @throws will throw if the given country is empty
 */
function mapCountryToPublicLang(country) {
  if (!country) throw new Error('must provide country');
  var langMap = {
    DE: 'de-de',
    AU: 'en-au',
    CA: 'en-ca',
    GB: 'en-uk',
    US: 'en-us',
    JP: 'ja-jp',
    SP: 'sp-mx',
    CN: 'zh-hans-cn'
  };

  return langMap[country.toUpperCase()] || 'en-us';
}

/**
 * Determines the public appcenter canonical link should be used based on the host and mapping
 * @param {string} path the current path
 * @return {string} canonical link should use in canonical link tag
 */
function getCanonicalLink(host, location) {
  if (!host) throw new Error('must provide host');

  var appCentreDomains = ['concur.co.uk', 'concur.com.au', 'concur.ca'];
  var appCenterLocation = location.replace('app-centre', 'app-center');
  var appCentereLocation = location.replace('app-center', 'app-centre');

  return appCentreDomains.some(function (domain) {
    return host.toLowerCase().includes(domain);
  }) ? 'https://' + host + appCentereLocation : 'https://' + host + appCenterLocation;
}

/**
 * In order to do international SEO for public appcenter, we need to push all the public appcenter sites with hreflang tag
 * @param {object[]} path the current path
 * @return {object[]} canonical link should use in canonical link tag
 */
function getHreflangLinks(links) {

  var useEnGB = ['https://www.concur.com.au', 'https://www.concur.co.uk', 'https://www.concur.ca'];

  var hrefs = {
    'https://www.concur.co.jp': 'ja',
    'https://www.concur.co.uk': 'en-gb',
    'https://www.concur.com.au': 'en-au',
    'https://www.concur.com': 'en-us',
    'https://www.concur.de': 'de-de',
    'https://www.concur.ca': 'en-ca'
  };

  for (var href in hrefs) {
    var path = '/app-center/';

    if (useEnGB.includes(href)) {
      path = '/app-centre/';
    }

    links.push({ rel: 'alternate', href: href + path, hreflang: hrefs[href] });
  }
}

/**
 * Sets page_name and triggers a view metric for public logging (concur.com)
 */
function sendPublicView() {
  if (canUseDOM() && window.getPagePath) {
    var pageName = window.getPagePath('page_name');
    window.utag_data.page_name = pageName;
    window.utag.view({ page_name: pageName });
  }
}

/**
 * Strips out HTML tag characters from provided string
 * @param {string} text the potentially unsafe text to sanitize
 * @returns {string} string with dangerous characters removed
 */
function escapeHTML(text) {
  var map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;'
  };

  return text.replace(/[&<>"]/g, function (m) {
    return map[m];
  });
}


//////////////////
// WEBPACK FOOTER
// ./lib/utils/index.js
// module id = 12
// module chunks = 0